module.exports = __webpack_public_path__ + "static/media/allocab.e9a22b7f.png";